<template>
    <div class="tree-ul-line">
        <div v-if="mode['flag']"
             class="tree-ul-country-flag"
        >
        </div>
        <CheckBox :title="setCheckBoxTitle"
                  :chosen="nodeValue.isChosen"
                  :partiallyFill="nodeValue.isPartiallyChosen"
                  :htmlTitle="mode['highlight']
                                || Object.keys(styled).length > 0"
                  @change="choose({level: nodeValue.nodeLevel, id: nodeValue.obj.id})"
        />
    </div>
</template>

<script>
    import CheckBox from 'checkbox';
    import { DecorateHelper } from 'reusable-helpers';

    export default {
        name: "HighLightedCheckBox",
        components: {CheckBox},
        props: {
            nodeValue: Object,
            searchText: String,
            mode: {
                type: Object,
                default: () => {
                    return {
                        flag: false,
                        highlight: false
                    }
                }
            },
            styled: {
                type: Object,
                required: false,
                default () {
                    return {}
                }
            }
        },
        computed: {
            setCheckBoxTitle () {
                let title = this.nodeValue.obj.name;
                if (this.searchText !== '') {
                    let substring = this.searchText.toLowerCase();
                    let checkBoxName = title.toLowerCase();

                    if (this.mode['highlight'] && checkBoxName.includes(substring)) {
                        title = DecorateHelper.highLightControlTitle(
                            title,
                            this.searchText,
                            '#ffe000',
                            'inherit'
                        );
                    }
                }

                if (Object.keys(this.styled).length > 0) {
                    switch (this.styled.styleType) {
                        case 'highlight': {
                            title = DecorateHelper.highLightControlTitle(
                                title,
                                title,
                                this.styled.backgroundColor,
                                this.styled.textColor
                            );
                            break;
                        }
                        case 'bold': {
                            title = DecorateHelper.boldControlTitle(title);
                            break;
                        }
                        default: break;
                    }
                }

                return title;
            },
        },
        methods: {
            choose (node) {
                this.$emit('choose-node', node);
            },
        }
    }
</script>

<style scoped>
    .tree-ul-line {
        display: flex;
        flex-direction: row;
    }

    .tree-ul-country-flag {
        background-image: url("../assets/russia_flag_icon.png");
        background-repeat: no-repeat;
        background-size: 24px;
        width: 24px;
        height: 16px;
        margin-right: 5px;
    }
</style>
